module.exports = Swiper;


//////////////////
// WEBPACK FOOTER
// external "Swiper"
// module id = GV3v
// module chunks = 16